export const SUMMARIZING_PARAGRAPH = {
  interests: [
    {
      code: 'RIA',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your problem solving skills and creative spirit!'
    },
    {
      code: 'RSA',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your sociable nature and creative spirit!'
    },
    {
      code: 'REA',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your natural leadership and creative spirit!'
    },
    {
      code: 'RCA',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your preference of structured approaches and creative spirit!'
    },
    {
      code: 'RAC',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your creative spirit and preference of structured approaches!'
    },
    {
      code: 'RIS',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your problem solving skills and sociable nature!'
    },
    {
      code: 'RSI',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your sociable nature and problem solving skills!'
    },
    {
      code: 'REI',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your natural leadership and problem solving skills!'
    },
    {
      code: 'RCI',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your preference of structured approaches and problem solving skills!'
    },
    {
      code: 'RAI',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your creative spirit and problem solving skills!'
    },
    {
      code: 'RIE',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your problem solving skills and natural leadership!'
    },
    {
      code: 'RSE',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your sociable nature and natural leadership!'
    },
    {
      code: 'RES',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your natural leadership and sociable nature!'
    },
    {
      code: 'RCS',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your preference of structured approaches and sociable nature!'
    },
    {
      code: 'RAS',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your creative spirit and sociable nature!'
    },
    {
      code: 'RIC',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your problem solving skills and preference of structured approaches!'
    },
    {
      code: 'RSC',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your sociable nature and preference of structured approaches!'
    },
    {
      code: 'REC',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your natural leadership and preference of structured approaches!'
    },
    {
      code: 'RCE',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your preference of structured approaches and natural leadership!'
    },
    {
      code: 'RAE',
      description:
        'Your combination of interests suggests an affinity for hands-on work, complemented by your creative spirit and natural leadership!'
    },
    {
      code: 'IRA',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your preference of hands-on work and creative spirit!'
    },
    {
      code: 'ISA',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your sociable nature and creative spirit!'
    },
    {
      code: 'IEA',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your natural leadership and creative spirit!'
    },
    {
      code: 'ICA',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your preference of structured approaches and creative spirit!'
    },
    {
      code: 'IAC',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your creative spirit and preference of structured approaches!'
    },
    {
      code: 'IRS',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your preference of hands-on work and sociable nature!'
    },
    {
      code: 'ISR',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your sociable nature and preference of hands-on work!'
    },
    {
      code: 'IER',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your natural leadership and problem solving skills!'
    },
    {
      code: 'ICR',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your preference of structured approaches and hands-on work!'
    },
    {
      code: 'IAR',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your creative spirit and preference of hands-on work!'
    },
    {
      code: 'IRE',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your preference of hands-on work and natural leadership!'
    },
    {
      code: 'ISE',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your sociable nature and natural leadership!'
    },
    {
      code: 'IES',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your natural leadership and sociable nature!'
    },
    {
      code: 'ICS',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your preference of structured approaches and sociable nature!'
    },
    {
      code: 'IAS',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your creative spirit and sociable nature!'
    },
    {
      code: 'IRC',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your preference of hands-on work and preference of structured approaches!'
    },
    {
      code: 'ISC',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your sociable nature and preference of structured approaches!'
    },
    {
      code: 'IEC',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your natural leadership and preference of structured approaches!'
    },
    {
      code: 'ICE',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your preference of structured approaches and natural leadership!'
    },
    {
      code: 'IAE',
      description:
        'Your combination of interests suggests an affinity for problem solving, complemented by your creative spirit and natural leadership!'
    },
    {
      code: 'AIR',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your problem solving skills and preference of hands-on work!'
    },
    {
      code: 'ASI',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your sociable nature and problem solving skills!'
    },
    {
      code: 'AEI',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your natural leadership and problem solving skills!'
    },
    {
      code: 'ACI',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your preference of structured approaches and problem solving skills!'
    },
    {
      code: 'ARI',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your preference of hands-on work and problem solving skills!'
    },
    {
      code: 'AIS',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your problem solving skills and sociable nature!'
    },
    {
      code: 'ASR',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your sociable nature and preference of hands-on work!'
    },
    {
      code: 'AER',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your natural leadership and preference of hands-on work!'
    },
    {
      code: 'ACR',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your preference of structured approaches and hands-on work!'
    },
    {
      code: 'ARC',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your preference of hands-on work and structured approaches!'
    },
    {
      code: 'AIE',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your problem solving skills and natural leadership!'
    },
    {
      code: 'ASE',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your sociable nature and natural leadership!'
    },
    {
      code: 'AES',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your natural leadership and sociable nature!'
    },
    {
      code: 'ACS',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your preference of structured approaches and sociable nature!'
    },
    {
      code: 'ARS',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your preference of hands-on work and sociable nature!'
    },
    {
      code: 'AIC',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your problem solving skills and preference of structured approaches!'
    },
    {
      code: 'ASC',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your sociable nature and preference of structured approaches!'
    },
    {
      code: 'AEC',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your natural leadership and preference of structured approaches!'
    },
    {
      code: 'ACE',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your preference of structured approaches and natural leadership!'
    },
    {
      code: 'ARE',
      description:
        'Your combination of interests suggests an affinity for creativity, complemented by your preference of hands-on work and natural leadership!'
    },
    {
      code: 'SIR',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your problem solving skills and preference of hands-on work!'
    },
    {
      code: 'SAI',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your creative spirit and problem solving skills!'
    },
    {
      code: 'SEI',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your natural leadership and problem solving skills!'
    },
    {
      code: 'SCI',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your preference of structured approaches and problem solving skills!'
    },
    {
      code: 'SRI',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your preference of hands-on work and problem solving skills!'
    },
    {
      code: 'SIA',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your problem solving skills and creative spirit!'
    },
    {
      code: 'SAR',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your creative spirit and preference of hands-on work!'
    },
    {
      code: 'SER',
      description:
        'Your combination of interests suggests an affinity for sociability complemented by your natural leadership and preference of hands-on work!'
    },
    {
      code: 'SCR',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your preference of structured approaches and hands-on work!'
    },
    {
      code: 'SRC',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your preference of hands-on work and structured approaches!'
    },
    {
      code: 'SIE',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your problem solving skills and natural leadership!'
    },
    {
      code: 'SAE',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your creative spirit and natural leadership!'
    },
    {
      code: 'SEA',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your natural leadership and creative spirit!'
    },
    {
      code: 'SCA',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your preference of structured approaches and sociable nature!'
    },
    {
      code: 'SRA',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your preference of hands-on work and sociable nature!'
    },
    {
      code: 'SIC',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your problem solving skills and preference of structured approaches!'
    },
    {
      code: 'SAC',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your creative spirit and preference of structured approaches!'
    },
    {
      code: 'SEC',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your natural leadership and preference of structured approaches!'
    },
    {
      code: 'SCE',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your preference of structured approaches and natural leadership!'
    },
    {
      code: 'SRE',
      description:
        'Your combination of interests suggests an affinity for sociability, complemented by your preference of hands-on work and natural leadership!'
    },
    {
      code: 'EIR',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your problem solving skills and preference of hands-on work!'
    },
    {
      code: 'EAI',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your creative spirit and problem solving skills!'
    },
    {
      code: 'ESI',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your sociable nature and problem solving skills!'
    },
    {
      code: 'ECI',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your preference of structured approaches and problem solving skills!'
    },
    {
      code: 'ERI',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your preference of hands-on work and problem solving skills!'
    },
    {
      code: 'EIA',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your problem solving skills and creative spirit!'
    },
    {
      code: 'EAR',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your creative spirit and preference of hands-on work!'
    },
    {
      code: 'ESR',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your sociable nature and preference of hands-on work!'
    },
    {
      code: 'ECR',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your preference of structured approaches and hands-on work!'
    },
    {
      code: 'ERC',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your preference of hands-on work and structured approaches!'
    },
    {
      code: 'EIS',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your problem solving skills and sociable nature!'
    },
    {
      code: 'EAS',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your creative spirit and sociable nature!'
    },
    {
      code: 'ESA',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your sociable nature and creative spirit!'
    },
    {
      code: 'ECA',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your preference of structured approaches and creative spirit!'
    },
    {
      code: 'ERA',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your preference of hands-on work and creative spirit!'
    },
    {
      code: 'EIC',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your problem solving skills and preference of structured approaches!'
    },
    {
      code: 'EAC',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your creative spirit and preference of structured approaches!'
    },
    {
      code: 'ESC',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your sociable nature and preference of structured approaches!'
    },
    {
      code: 'ECS',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your natural leadership and sociable nature!'
    },
    {
      code: 'ERS',
      description:
        'Your combination of interests suggests an affinity for leadership, complemented by your preference of hands-on work and sociable nature!'
    },
    {
      code: 'CIR',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your problem solving skills and preference of hands-on work!'
    },
    {
      code: 'CAI',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your creative spirit and problem solving skills!'
    },
    {
      code: 'CSI',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your sociable nature and problem solving skills!'
    },
    {
      code: 'CEI',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your natural leadership and problem solving skills!'
    },
    {
      code: 'CRI',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your preference of hands-on work and problem solving skills!'
    },
    {
      code: 'CIA',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your problem solving skills and creative spirit!'
    },
    {
      code: 'CAR',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your creative spirit and preference of hands-on work!'
    },
    {
      code: 'CSR',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your sociable nature and preference of hands-on work!'
    },
    {
      code: 'CER',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your natural leadership and preference of hands-on work!'
    },
    {
      code: 'CRE',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your preference of hands-on work and natural leadership!'
    },
    {
      code: 'CIS',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your problem solving skills and sociable nature!'
    },
    {
      code: 'CAS',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your creative spirit and sociable nature!'
    },
    {
      code: 'CSA',
      description:
        'Your combination of interests suggests an affinity for or structured approaches, complemented by your sociable nature and creative spirit!'
    },
    {
      code: 'CEA',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your natural leadership and creative spirit!'
    },
    {
      code: 'CRA',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your preference of hands-on work and creative spirit!'
    },
    {
      code: 'CIE',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your problem solving skills and natural leadership!'
    },
    {
      code: 'CAE',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your creative spirit and natural leadership!'
    },
    {
      code: 'CSE',
      description:
        'Your combination of interests suggests an affinity for or structured approaches, complemented by your sociable nature and natural leadership!'
    },
    {
      code: 'CES',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your natural leadership and sociable nature!'
    },
    {
      code: 'CRS',
      description:
        'Your combination of interests suggests an affinity for structured approaches, complemented by your preference of hands-on work and sociable nature!'
    }
  ],
  workValues: [
    {
      code: 'Achievement,Independence,Recognition',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire for autonomy, and the pursuit of recognition in your career.'
    },
    {
      code: 'Achievement,Independence,Relationships',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire for autonomy, and a focus on providing service to others.'
    },
    {
      code: 'Achievement,Independence,Support',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire for autonomy, and a preference for supervision.'
    },
    {
      code: 'Achievement,Independence,Working Conditions',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire for autonomy, and a need for a secure work environment.'
    },
    {
      code: 'Achievement,Recognition,Independence',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a focus on leadership potential, and the ability to make your own decisions.'
    },
    {
      code: 'Achievement,Recognition,Relationships',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a focus on leadership potential, and a focus on providing service to others.'
    },
    {
      code: 'Achievement,Recognition,Support',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a focus on leadership potential, and a preference for supervision.'
    },
    {
      code: 'Achievement,Recognition,Working Conditions',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a focus on leadership potential, and a need for a secure work environment.'
    },
    {
      code: 'Achievement,Relationships,Independence',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire to work in a friendly environment, and the ability to make your own decisions.'
    },
    {
      code: 'Achievement,Relationships,Recognition',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire to work in a friendly environment, and the pursuit of recognition in your career.'
    },
    {
      code: 'Achievement,Relationships,Support',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire to work in a friendly environment, and a preference for supervision.'
    },
    {
      code: 'Achievement,Relationships,Working Conditions',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire to work in a friendly environment, and a need for a secure work environment.'
    },
    {
      code: 'Achievement,Support,Independence',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a focus on human relations, and the ability to make your own decisions.'
    },
    {
      code: 'Achievement,Support,Recognition',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a focus on human relations, and the pursuit of recognition in your career.'
    },
    {
      code: 'Achievement,Support,Relationships',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a focus on human relations, and a focus on providing service to others.'
    },
    {
      code: 'Achievement,Support,Working Conditions',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a focus on human relations, and a need for a secure work environment.'
    },
    {
      code: 'Achievement,Working Conditions,Independence',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire for job security, and the ability to make your own decisions.'
    },
    {
      code: 'Achievement,Working Conditions,Recognition',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire for job security, and the pursuit of recognition in your career.'
    },
    {
      code: 'Achievement,Working Conditions,Relationships',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire for job security, and a focus on providing service to others.'
    },
    {
      code: 'Achievement,Working Conditions,Support',
      description:
        'Your combination of values suggests a drive for achievement, complemented by a desire for job security, and a preference for supervision.'
    },
    {
      code: 'Independence,Achievement,Recognition',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire to achieve, and the pursuit of recognition in your career.'
    },
    {
      code: 'Independence,Achievement,Relationships',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire to achieve, and a focus on providing service to others.'
    },
    {
      code: 'Independence,Achievement,Support',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire to achieve, and a preference for supervision.'
    },
    {
      code: 'Independence,Achievement,Working Conditions',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire to achieve, and a need for a secure work environment.'
    },
    {
      code: 'Independence,Recognition,Achievement',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a focus on leadership potential, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Independence,Recognition,Relationships',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a focus on leadership potential, and a focus on providing service to others.'
    },
    {
      code: 'Independence,Recognition,Support',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a focus on leadership potential, and a preference for supervision.'
    },
    {
      code: 'Independence,Recognition,Working Conditions',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a focus on leadership potential, and a need for a secure work environment.'
    },
    {
      code: 'Independence,Relationships,Achievement',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire to work in a friendly environment, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Independence,Relationships,Recognition',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire to work in a friendly environment, and the pursuit of recognition in your career.'
    },
    {
      code: 'Independence,Relationships,Support',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire to work in a friendly environment, and a preference for supervision.'
    },
    {
      code: 'Independence,Relationships,Working Conditions',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire to work in a friendly environment, and a need for a secure work environment.'
    },
    {
      code: 'Independence,Support,Achievement',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a focus on human relations, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Independence,Support,Recognition',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a focus on human relations, and the pursuit of recognition in your career.'
    },
    {
      code: 'Independence,Support,Relationships',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a focus on human relations, and a focus on providing service to others.'
    },
    {
      code: 'Independence,Support,Working Conditions',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a focus on human relations, and a need for a secure work environment.'
    },
    {
      code: 'Independence,Working Conditions,Achievement',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire for job security, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Independence,Working Conditions,Recognition',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire for job security, and the pursuit of recognition in your career.'
    },
    {
      code: 'Independence,Working Conditions,Relationships',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire for job security, and a focus on providing service to others.'
    },
    {
      code: 'Independence,Working Conditions,Support',
      description:
        'Your combination of values suggests a preference for working independently, complemented by a desire for job security, and a preference for supervision.'
    },
    {
      code: 'Recognition,Achievement,Independence',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire to achieve, and the ability to make your own decisions.'
    },
    {
      code: 'Recognition,Achievement,Relationships',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire to achieve, and a focus on providing service to others.'
    },
    {
      code: 'Recognition,Achievement,Support',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire to achieve, and a preference for supervision.'
    },
    {
      code: 'Recognition,Achievement,Working Conditions',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire to achieve, and a need for a secure work environment.'
    },
    {
      code: 'Recognition,Independence,Achievement',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire for autonomy, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Recognition,Independence,Relationships',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire for autonomy, and a focus on providing service to others.'
    },
    {
      code: 'Recognition,Independence,Support',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire for autonomy, and a preference for supervision.'
    },
    {
      code: 'Recognition,Independence,Working Conditions',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire for autonomy, and a need for a secure work environment.'
    },
    {
      code: 'Recognition,Relationships,Achievement',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire to work in a friendly environment, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Recognition,Relationships,Independence',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire to work in a friendly environment, and the ability to make your own decisions.'
    },
    {
      code: 'Recognition,Relationships,Support',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire to work in a friendly environment, and a preference for supervision.'
    },
    {
      code: 'Recognition,Relationships,Working Conditions',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire to work in a friendly environment, and a need for a secure work environment.'
    },
    {
      code: 'Recognition,Support,Achievement',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a focus on human relations, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Recognition,Support,Independence',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a focus on human relations, and the ability to make your own decisions.'
    },
    {
      code: 'Recognition,Support,Relationships',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a focus on human relations, and a focus on providing service to others.'
    },
    {
      code: 'Recognition,Support,Working Conditions',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a focus on human relations, and a need for a secure work environment.'
    },
    {
      code: 'Recognition,Working Conditions,Achievement',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire for job security, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Recognition,Working Conditions,Independence',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire for job security, and the ability to make your own decisions.'
    },
    {
      code: 'Recognition,Working Conditions,Relationships',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire for job security, and a focus on providing service to others.'
    },
    {
      code: 'Recognition,Working Conditions,Support',
      description:
        'Your combination of values suggests a desire for recognition, complemented by a desire for job security, and a preference for supervision.'
    },
    {
      code: 'Relationships,Achievement,Independence',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire to achieve, and the ability to make your own decisions.'
    },
    {
      code: 'Relationships,Achievement,Recognition',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire to achieve, and the pursuit of recognition in your career.'
    },
    {
      code: 'Relationships,Achievement,Support',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire to achieve, and a preference for supervision.'
    },
    {
      code: 'Relationships,Achievement,Working Conditions',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire to achieve, and a need for a secure work environment.'
    },
    {
      code: 'Relationships,Independence,Achievement',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire for autonomy, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Relationships,Independence,Recognition',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire for autonomy, and the pursuit of recognition in your career.'
    },
    {
      code: 'Relationships,Independence,Support',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire for autonomy, and a preference for supervision.'
    },
    {
      code: 'Relationships,Independence,Working Conditions',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire for autonomy, and a need for a secure work environment.'
    },
    {
      code: 'Relationships,Recognition,Achievement',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a focus on leadership potential, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Relationships,Recognition,Independence',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a focus on leadership potential, and the ability to make your own decisions.'
    },
    {
      code: 'Relationships,Recognition,Support',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a focus on leadership potential, and a preference for supervision.'
    },
    {
      code: 'Relationships,Recognition,Working Conditions',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a focus on leadership potential, and a need for a secure work environment.'
    },
    {
      code: 'Relationships,Support,Achievement',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a focus on human relations, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Relationships,Support,Independence',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a focus on human relations, and the ability to make your own decisions.'
    },
    {
      code: 'Relationships,Support,Recognition',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a focus on human relations, and the pursuit of recognition in your career.'
    },
    {
      code: 'Relationships,Support,Working Conditions',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a focus on human relations, and a need for a secure work environment.'
    },
    {
      code: 'Relationships,Working Conditions,Achievement',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire for job security, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Relationships,Working Conditions,Independence',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire for job security, and the ability to make your own decisions.'
    },
    {
      code: 'Relationships,Working Conditions,Recognition',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire for job security, and the pursuit of recognition in your career.'
    },
    {
      code: 'Relationships,Working Conditions,Support',
      description:
        'Your combination of values suggests a commitment to building relationships, complemented by a desire for job security, and a preference for supervision.'
    },
    {
      code: 'Support,Achievement,Independence',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire to achieve, and the ability to make your own decisions.'
    },
    {
      code: 'Support,Achievement,Recognition',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire to achieve, and the pursuit of recognition in your career.'
    },
    {
      code: 'Support,Achievement,Relationships',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire to achieve, and a focus on providing service to others.'
    },
    {
      code: 'Support,Achievement,Working Conditions',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire to achieve, and a need for a secure work environment.'
    },
    {
      code: 'Support,Independence,Achievement',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire for autonomy, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Support,Independence,Recognition',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire for autonomy, and the pursuit of recognition in your career.'
    },
    {
      code: 'Support,Independence,Relationships',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire for autonomy, and a focus on providing service to others.'
    },
    {
      code: 'Support,Independence,Working Conditions',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire for autonomy, and a need for a secure work environment.'
    },
    {
      code: 'Support,Recognition,Achievement',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a focus on leadership potential, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Support,Recognition,Independence',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a focus on leadership potential, and the ability to make your own decisions.'
    },
    {
      code: 'Support,Recognition,Relationships',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a focus on leadership potential, and a focus on providing service to others.'
    },
    {
      code: 'Support,Recognition,Working Conditions',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a focus on leadership potential, and a need for a secure work environment.'
    },
    {
      code: 'Support,Relationships,Achievement',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire to work in a friendly environment, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Support,Relationships,Independence',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire to work in a friendly environment, and the ability to make your own decisions.'
    },
    {
      code: 'Support,Relationships,Recognition',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire to work in a friendly environment, and the pursuit of recognition in your career.'
    },
    {
      code: 'Support,Relationships,Working Conditions',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire to work in a friendly environment, and a need for a secure work environment.'
    },
    {
      code: 'Support,Working Conditions,Achievement',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire for job security, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Support,Working Conditions,Independence',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire for job security, and the ability to make your own decisions.'
    },
    {
      code: 'Support,Working Conditions,Recognition',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire for job security, and the pursuit of recognition in your career.'
    },
    {
      code: 'Support,Working Conditions,Relationships',
      description:
        'Your combination of values suggests a need for supportive management, complemented by a desire for job security, and a focus on providing service to others.'
    },
    {
      code: 'Working Conditions,Achievement,Independence',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire to achieve, and the ability to make your own decisions.'
    },
    {
      code: 'Working Conditions,Achievement,Recognition',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire to achieve, and the pursuit of recognition in your career.'
    },
    {
      code: 'Working Conditions,Achievement,Relationships',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire to achieve, and a focus on providing service to others.'
    },
    {
      code: 'Working Conditions,Achievement,Support',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire to achieve, and a preference for supervision.'
    },
    {
      code: 'Working Conditions,Independence,Achievement',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire for autonomy, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Working Conditions,Independence,Recognition',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire for autonomy, and the pursuit of recognition in your career.'
    },
    {
      code: 'Working Conditions,Independence,Relationships',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire for autonomy, and a focus on providing service to others.'
    },
    {
      code: 'Working Conditions,Independence,Support',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire for autonomy, and a preference for supervision.'
    },
    {
      code: 'Working Conditions,Recognition,Achievement',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a focus on leadership potential, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Working Conditions,Recognition,Independence',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a focus on leadership potential, and the ability to make your own decisions.'
    },
    {
      code: 'Working Conditions,Recognition,Relationships',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a focus on leadership potential, and a focus on providing service to others.'
    },
    {
      code: 'Working Conditions,Recognition,Support',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a focus on leadership potential, and a preference for supervision.'
    },
    {
      code: 'Working Conditions,Relationships,Achievement',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire to work in a friendly environment, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Working Conditions,Relationships,Independence',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire to work in a friendly environment, and the ability to make your own decisions.'
    },
    {
      code: 'Working Conditions,Relationships,Recognition',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire to work in a friendly environment, and the pursuit of recognition in your career.'
    },
    {
      code: 'Working Conditions,Relationships,Support',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a desire to work in a friendly environment, and a preference for supervision.'
    },
    {
      code: 'Working Conditions,Support,Achievement',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a focus on human relations, and a need for accomplishment to feel fulfilled.'
    },
    {
      code: 'Working Conditions,Support,Independence',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a focus on human relations, and the ability to make your own decisions.'
    },
    {
      code: 'Working Conditions,Support,Recognition',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a focus on human relations, and the pursuit of recognition in your career.'
    },
    {
      code: 'Working Conditions,Support,Relationships',
      description:
        'Your combination of values suggests a preference for stable working conditions, complemented by a focus on human relations, and a focus on providing service to others.'
    }
  ]
};
